import type { Read } from "@/components/ui/box.schema";
import type { AdminSection } from "@/lib/api/dashboard";

/** An interrupted section is never a count, and a refresh preserves its last read. */
export function homeRead<T>(section: AdminSection<T> | undefined, options: {
  readAt: string | undefined;
  empty: string;
  failed: string;
  stale: boolean;
  retry: () => void;
}): Read<T> {
  if (!section) return { status: "loading" };
  if (section.state === "unavailable") return { status: "failed", sentence: options.failed, retry: options.retry };
  if (section.state === "empty") return options.stale
    ? { status: "failed", sentence: options.failed, retry: options.retry }
    : { status: "empty", sentence: options.empty };
  const readAt = options.readAt;
  if (!readAt) return { status: "failed", sentence: options.failed, retry: options.retry };
  return options.stale ? { status: "stale", last: section.value, readAt, sentence: options.failed, refresh: options.retry }
    : { status: "ready", value: section.value, readAt };
}
